export default __webpack_public_path__ + "static/media/mcgill.8ebfefa6.png";